module.exports = __webpack_public_path__ + "static/media/check.a9425537.mp3";